module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('administracao.perfilAcesso.titulos.perfisAcesso'),
      "subTitle": _vm.$t('administracao.perfilAcesso.titulos.listagemSubtitlo')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('administracao.perfilAcesso.labels.novoPerfil'),
      "clickFunction": _vm.newProfile,
      "id": "btnNovoPerfilDeAcesso"
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "profiles"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.profiles,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "title": _vm.isMasterProfile(props.row.id) ? _vm.$t('administracao.perfilAcesso.validacao.naoPodeEditar') : ''
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__nome"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'nome')
      }
    }
  })])], 2)], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a1a5a18", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a1a5a18"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/administration/accessProfile/list.pug
// module id = 1443
// module chunks = 0